import { OddsType } from "app/utils/const";
import cx from "classnames";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { FormattedNumber } from "react-intl";
import IconSports from "../../../../../../components/Icon/components/IconSports/IconSports";
import LandingPageChart from "./LandingPageChart";
import "./LandingPageChartContainer.scss";

type Props = {
  selectedOddsType: string;
  data: Record<string, any>;
};

const LandingPageChartContainer: React.FC<Props> = ({
  selectedOddsType,
  data,
}) => {
  const {
    marketName,
    runnerData,
    marketCloseDate,
    liquidityOfBestRunner,
    eventName,
    sportType,
  } = data;

  dayjs.extend(utc);
  const date = dayjs(marketCloseDate).utc().format("DD MMM YYYY  HH:mm");
  let runnerLeft, runnerRight;
  let runnerLeftoddsAtMarketClose, runnerRightoddsAtMarketClose;
  const hasThreeRunners = runnerData && runnerData.length === 3;

  if (runnerData && runnerData.length === 2) {
    runnerLeft = runnerData[0].runnerFormattedName;

    runnerRight = runnerData[1].runnerFormattedName;
    runnerLeftoddsAtMarketClose =
      selectedOddsType === OddsType.US
        ? runnerData[0].usOddsAtMarketClose
        : runnerData[0].decimalOddsAtMarketClose;

    runnerRightoddsAtMarketClose =
      selectedOddsType === OddsType.US
        ? runnerData[1].usOddsAtMarketClose
        : runnerData[1].decimalOddsAtMarketClose;
  } else if (runnerData && runnerData.length === 3) {
    runnerLeft = runnerData[0].runnerFormattedName;

    runnerRight = runnerData[2].runnerFormattedName;
    runnerLeftoddsAtMarketClose =
      selectedOddsType === OddsType.US
        ? runnerData[0].usOddsAtMarketClose
        : runnerData[0].decimalOddsAtMarketClose;

    runnerRightoddsAtMarketClose =
      selectedOddsType === OddsType.US
        ? runnerData[2].usOddsAtMarketClose
        : runnerData[2].decimalOddsAtMarketClose;
  }

  return (
    <div>
      <div className="chart-container">
        <div className="chart-container__date">{date}</div>

        <div className="chart-container__header">
          <div className="chart-container__header__icon">
            {sportType ? (
              <IconSports
                name={sportType}
                className="chart-container__header__icon--green"
              />
            ) : (
              <IconSports
                name={"soccer"}
                className="chart-container__header__icon--green"
              />
            )}
          </div>

          <div className="chart-container__event-name">{eventName}</div>
        </div>
        <div className="chart-container__market">
          <span className="chart-container__market__text">{marketName}</span>

          <div className="chart-container__market__runners">
            <span className="chart-container__market__team chart-container__market__team--left">
              {runnerLeft}
            </span>

            <span className="chart-container__market__team chart-container__market__team--right">
              {runnerRight}
            </span>
            <div className="chart-container__dots">
              <div className="chart-container__dot-container">
                <span className="chart-container__dot chart-container__dot--left" />
              </div>
              <div className="chart-container__dot-container">
                <span className="chart-container__dot chart-container__dot--right" />
              </div>
            </div>
          </div>

          {runnerData &&
            (runnerData[0].decimalOddsAtMarketClose ||
              runnerData[0].usOddsAtMarketClose) && (
              <div className="chart-container__oddsBoxes">
                <div className="chart-container__oddsBox-container">
                  <span
                    className={cx(
                      "chart-container__oddsBox",
                      {
                        "chart-container__oddsBox--left": !hasThreeRunners,
                      },
                      {
                        "chart-container__oddsBox--three-runners-left":
                          hasThreeRunners,
                      }
                    )}
                  >
                    <span className="chart-container__oddsBox__text">
                      {runnerLeftoddsAtMarketClose &&
                        runnerLeftoddsAtMarketClose > 0 &&
                        selectedOddsType === OddsType.US &&
                        "+"}
                      {selectedOddsType === OddsType.US ? (
                        runnerLeftoddsAtMarketClose
                      ) : (
                        <span>
                          <FormattedNumber
                            value={runnerLeftoddsAtMarketClose}
                            minimumFractionDigits={3}
                            maximumFractionDigits={3}
                          />
                        </span>
                      )}
                    </span>
                  </span>
                </div>
                {/* <span className="chart-container__oddsBox chart-container__oddsBox--right"> */}
                {/* <span className="chart-container__oddsBox chart-container__oddsBox--right"> */}
                <div className="chart-container__oddsBox-container">
                  <span
                    className={cx(
                      "chart-container__oddsBox",
                      {
                        "chart-container__oddsBox--right": !hasThreeRunners,
                      },
                      {
                        "chart-container__oddsBox--three-runners-right":
                          hasThreeRunners,
                      }
                    )}
                  >
                    <span className="chart-container__oddsBox__text">
                      {runnerRightoddsAtMarketClose &&
                        runnerRightoddsAtMarketClose > 0 &&
                        selectedOddsType === OddsType.US &&
                        "+"}
                      {selectedOddsType === OddsType.US ? (
                        runnerRightoddsAtMarketClose
                      ) : (
                        <span>
                          <FormattedNumber
                            value={runnerRightoddsAtMarketClose}
                            minimumFractionDigits={3}
                            maximumFractionDigits={3}
                          />
                        </span>
                      )}
                    </span>
                  </span>
                </div>
              </div>
            )}
        </div>

        <LandingPageChart
          currencyCode={"USD"}
          selectedOddsType={selectedOddsType}
          runnerData={runnerData}
          liquidityOfBestRunner={liquidityOfBestRunner}
        />
      </div>
    </div>
  );
};

export default LandingPageChartContainer;
